import React, { ComponentProps, HTMLAttributes, useCallback } from "react";

import cn from "classnames";

import styles from "./ToggleButton.module.scss";

type ToggleButtonProps = {
  active?: boolean;
} & HTMLAttributes<HTMLSpanElement>;

export const ToggleButton = ({
  active,
  children,
  className,
  onMouseDown,
  ...props
}: ToggleButtonProps) => {
  const handleMouseDown = useCallback<NonNullable<ComponentProps<"span">["onMouseDown"]>>(
    (e) => {
      // editor should not lose focus and show active caret when user click on toolbar button
      e.preventDefault();
      onMouseDown?.(e);
    },
    [onMouseDown]
  );

  return (
    <span
      {...props}
      className={cn(styles.container, { [styles.active]: active }, className)}
      onMouseDown={handleMouseDown}
    >
      {children}
    </span>
  );
};

export default ToggleButton;
